function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { INPUT } from "../../components/form-styles";
import { searchContacts, friendly } from "./compose-api";

/*
 * Composer preview rail (2026-10-04): the server render in an iframe with a
 * desktop (600) / mobile (375) toggle, "Preview as…" contact picker (the
 * composer re-renders with personId) and "Send test to me" when the host
 * passes onSendTest. The per-email style overrides are already injected into
 * `html` by the composer.
 */

const DESKTOP_W = 600,
  MOBILE_W = 375;
export default class PreviewPane extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "measure", () => {
      const el = this.wrap.current;
      if (el && el.clientWidth !== this.state.width) this.setState({
        width: el.clientWidth
      });
    });
    _defineProperty(this, "search", q => {
      clearTimeout(this._t);
      this._t = setTimeout(async () => {
        if (!q.trim()) {
          this.setState({
            rows: null
          });
          return;
        }
        try {
          const rows = await searchContacts(q);
          if (this._alive) this.setState({
            rows,
            err: null
          });
        } catch (e) {
          if (this._alive) this.setState({
            rows: [],
            err: friendly(e, "Contact search isn't available right now.")
          });
        }
      }, 250);
    });
    this.state = {
      device: "desktop",
      picking: false,
      q: "",
      rows: null,
      err: null,
      width: 0
    };
    this.wrap = /*#__PURE__*/React.createRef();
    this._alive = true;
  }
  componentDidMount() {
    this.measure();
    window.addEventListener("resize", this.measure);
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._t);
    window.removeEventListener("resize", this.measure);
  }
  render() {
    const {
      html,
      busy,
      err,
      person,
      onPerson,
      onSendTest,
      testBusy,
      testNote,
      renderErr
    } = this.props;
    const {
      device,
      picking,
      q,
      rows,
      width
    } = this.state;
    const w = device === "mobile" ? MOBILE_W : DESKTOP_W;
    const inner = Math.max(0, width - 2);
    const scale = inner && inner < w ? inner / w : 1;
    const frameH = 620;
    const who = person ? `Rendered for ${person.name || person.email || "contact " + person.id}` : "Rendered for Dana (sample)";
    return /*#__PURE__*/React.createElement("div", {
      className: "cmp-preview"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cmp-preview-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "cmp-preview-title"
    }, "Preview", busy ? " · rendering…" : ""), /*#__PURE__*/React.createElement("span", {
      className: "cmp-seg"
    }, /*#__PURE__*/React.createElement("a", {
      className: device === "desktop" ? "on" : "",
      onClick: () => this.setState({
        device: "desktop"
      }),
      title: "Desktop (600px)"
    }, "Desktop"), /*#__PURE__*/React.createElement("a", {
      className: device === "mobile" ? "on" : "",
      onClick: () => this.setState({
        device: "mobile"
      }),
      title: "Mobile (375px)"
    }, "Mobile"))), /*#__PURE__*/React.createElement("div", {
      className: "cmp-preview-who"
    }, /*#__PURE__*/React.createElement("span", null, who), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link",
      onClick: () => this.setState({
        picking: !picking,
        q: "",
        rows: null
      })
    }, picking ? "close" : "Preview as…"), person ? /*#__PURE__*/React.createElement("a", {
      className: "cmp-link dim",
      onClick: () => onPerson(null)
    }, "sample again") : null), picking ? /*#__PURE__*/React.createElement("div", {
      className: "ec-picker cmp-person"
    }, /*#__PURE__*/React.createElement("input", {
      style: INPUT,
      autoFocus: true,
      value: q,
      placeholder: "Search contacts by name or email",
      onChange: e => {
        this.setState({
          q: e.target.value
        });
        this.search(e.target.value);
      },
      onKeyDown: e => {
        if (e.key === "Escape") this.setState({
          picking: false
        });
      }
    }), this.state.err ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-warn"
    }, this.state.err) : null, /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-list"
    }, !q.trim() ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Type to search. The email renders with that person's real name and products.") : rows == null ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Searching\u2026") : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "No contact matches.") : rows.map(r => /*#__PURE__*/React.createElement("button", {
      key: r.id,
      type: "button",
      onClick: () => {
        onPerson(r);
        this.setState({
          picking: false
        });
      }
    }, /*#__PURE__*/React.createElement("span", null, r.name || r.email || r.id), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.name ? r.email : ""))))) : null, /*#__PURE__*/React.createElement("div", {
      ref: this.wrap,
      className: "cmp-frame" + (device === "mobile" ? " mobile" : ""),
      style: {
        height: frameH
      }
    }, html ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-frame-scale",
      style: {
        width: w,
        height: frameH / scale,
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        margin: device === "mobile" && scale === 1 ? "0 auto" : 0
      }
    }, /*#__PURE__*/React.createElement("iframe", {
      title: "Email preview",
      sandbox: "",
      style: {
        width: w,
        height: "100%",
        border: 0,
        display: "block",
        background: "#fff"
      },
      srcDoc: html
    })) : /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 12
      }
    }, renderErr || err || (busy ? "Rendering…" : "Add a section to see the email."))), onSendTest ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-preview-foot"
    }, testNote ? /*#__PURE__*/React.createElement("span", {
      className: "cmp-note" + (testNote.kind === "error" ? " bad" : "")
    }, testNote.text) : null, /*#__PURE__*/React.createElement(Button, {
      disabled: !!testBusy,
      onClick: onSendTest,
      title: "Emails this to you, rendered with sample data: nothing is saved"
    }, testBusy ? "Sending…" : "Send test to me")) : null);
  }
}